import type { InjectionKey, Ref } from 'vue'

export interface ProgressBar {
  active: boolean
  percent: number
}

export const ProgressBarKey: InjectionKey<Ref<ProgressBar>> = Symbol('ProgressBar')
